import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyAeSduhjnrQ4Ho7_ggDn0o4qwz5j1PhPNg",
    authDomain: "clone-e0b95.firebaseapp.com",
    databaseURL: "https://clone-e0b95.firebaseio.com",
    projectId: "clone-e0b95",
    storageBucket: "clone-e0b95.appspot.com",
    messagingSenderId: "815838427316",
    appId: "1:815838427316:web:fabcf1f58647ac12137fe1",
    measurementId: "G-CCD8E2Z664"
});

const db = firebaseApp.firestore();
const auth = firebase.auth();
export { auth };
